import { Injectable } from "@angular/core";
import { environment } from "./../../environments/environment"; //./environment-variables/environment-variables.module.ts";
import * as _ from "lodash";
@Injectable({
    providedIn: 'root'
})
export class UrlConstants {

    constructor() { }
    public getSingleItem = "fetch/{object}/{id1}/{id2}";
    public createItem = "create/{object}";
    public deleteItem = "delete/{object}";
    public updateItem = "update/{object}";
    public actionUnAuth = "actionunauth/{actionName}";
    public action = "action/{actionName}";
    public getList = "fetch/{object}/{id1}/{id2}";
    public vimeoData = "https://api.vimeo.com/videos/"
    public getUri(uri: string, params?: Array<UrlParams>): string {
        let newUri = uri;

        if (params) {
            // Select the queryParams that matches the incoming set from params
            for (let param of params) {

                newUri = newUri.replace(param.param, param.value);
            }
        }

        return environment.API_URL + newUri;
    }

}

export class UrlParams {
    public param: string;
    public value: string;
}